import { LayoutDashboard, Search, Package, DollarSign, Sparkles, FileText, User, Store, Container, Users, Gavel } from "lucide-react";

export const carrierNav = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard, end: true },
  { to: "/find-loads", label: "Find Loads", icon: Search },
  { to: "/dashboard/my-loads", label: "My Loads", icon: Package },
  { to: "/dashboard/bids", label: "My Bids", icon: Gavel },
  { to: "/dashboard/ai-dispatcher", label: "XD Dispatch AI", icon: Sparkles },
  { to: "/dashboard/money", label: "Revenue & Payments", icon: DollarSign },
  { to: "/dashboard/equipment", label: "Equipment", icon: Container },
  { to: "/dashboard/team", label: "Team", icon: Users },
  { to: "/dashboard/documents", label: "Documents", icon: FileText },
  { to: "/marketplace", label: "Marketplace", icon: Store },
  { to: "/dashboard/profile", label: "Profile", icon: User },
];
